'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = alert;
exports.show = show;
exports.hide = hide;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW = 'alert/SHOW';
var HIDE = 'alert/HIDE';

var initialState = {
  show: false
};

function alert() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SHOW:
      return (0, _extends3.default)({}, state, {
        show: true,
        module: action.module
      });
    case HIDE:
      return (0, _extends3.default)({}, state, {
        show: false,
        module: action.module
      });
    default:
      return state;
  }
}

function show(module) {
  return {
    type: SHOW,
    module: module
  };
}
function hide(module) {
  return {
    type: HIDE,
    module: module
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/alert.js
// module id = 119
// module chunks = 0